module.exports = __webpack_public_path__ + "media/images/lb/145-b86a200c0ee646a5423632258e50e69a.svg";